<template>
    <div>
        <div class="head-bar">
            <ls-filter :table="table" @change="(e) => {
                datas.add = { ...datas.add, ...e };
            }
                ">
                <el-input v-model="datas.add.id" placeholder="ID" clearable></el-input>
            </ls-filter>
        </div>
        <el-table v-loading="datas.status == -1" :data="datas.data" @sort-change="_sort" @selection-change="_select">
            <el-table-column prop="id" label="ID" width="100" sortable="custom"></el-table-column>
            <template v-for="(item, index) in mix_fields">
                <el-table-column :label="item.COLUMN_COMMENT" :width="item.width ? item.width : 'auto'" :key="index">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row[item.COLUMN_NAME] }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1" class="c-success">
                        启用
                    </span>
                    <span v-else class="c-danger">
                        禁用
                    </span>
                </template>
            </el-table-column>
            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <div class="handle-box">
                        <el-button type="text"
                            @click="e => { _ranks(scope.row.id); _save(scope.row.id) }">编辑</el-button>
                        <el-button type="text" @click="_del(scope.row.id)" class="c-danger">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-box">
            <el-pagination @size-change="_size" @current-change="_page" :current-page="datas.page"
                :page-sizes="[10, 20, 50, 100]" :page-size="datas.limit" layout="total, sizes, prev, pager, next"
                :total="datas.total"></el-pagination>
        </div>
        <ls-table-data :table="table" @fields="(e) => {
                mix_fields = e;
            }
                "></ls-table-data>
        <ls-mask v-if="show_save" @close="show_save = false" :title="r.id ? '编辑' : '新增'" width="500px">
            <el-form label-width="100px">
                <el-form-item label="手机号">
                    <el-input v-model="r.user_name"></el-input>
                </el-form-item>
                <el-form-item label="启用">
                    <el-switch v-model="r.status" :active-value="1" :inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="发布信息">
                    <el-switch v-model="r.is_add" :active-value="1" :inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="查看">
                    <el-switch v-model="r.is_see" :active-value="1" :inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model="r.password"></el-input>
                    <p class="f-12 c-999">不修改请留空</p>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="_submit">提交</el-button>
                </el-form-item>
            </el-form>
        </ls-mask>
    </div>
</template>
<script>
export default {
    data() {
        return {
            table: 'user',
            groups: [],
            datas: {
                append: ['group', 'sex_text', 'sex_o_text', 'sex_p_text']
            },
            ranks: [],
            r: {
                icons: []
            }
        };
    },
    created() {
        this._groups();
        this._load();
    },
    methods: {
        _ranks(uid) {
            this.ranks = [];
            this.$http.post('pls/user_ranks', {
                uid
            }).then(res => {
                this.ranks = res.data;
            })
        },
        _groups() {
            this.$http.post('user_group/list').then((res) => {
                this.groups = res.data.data;
            });
        }
    }
};
</script>
<style lang="scss"></style>